export const SITE_ORIGIN = 'https://www.lulpay.com';

/**
 * Point <link rel="canonical"> at this page (index.html ships the home URL for every route).
 * Pass null on a page that has no canonical address, such as the 404 page.
 */
export function setCanonical(path: string | null): void {
  const existing = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (path == null) {
    existing?.remove();
    return;
  }
  const link = existing ?? document.createElement('link');
  link.rel = 'canonical';
  link.href = `${SITE_ORIGIN}${path}`;
  if (!existing) document.head.appendChild(link);
}
